// src/components/Dashboard/FarmSectionHeader.jsx
import React from 'react';
import clsx from 'clsx';

export const FarmSectionHeader = ({ title, icon }) => {
  return (
    <div className="flex items-center gap-3 mb-6">
      <div
        className={clsx(
          'p-2.5 rounded-lg border shadow-sm',
          'bg-white border-gray-200 text-fundo-green-700',
          'dark:bg-gray-900 dark:border-gray-700 dark:text-fundo-green-300'
        )}
      >
        {icon}
      </div>

      <h2 className="text-xl font-semibold text-gray-900 dark:text-gray-100 tracking-tight">
        {title}
      </h2>
    </div>
  );
};
